module.exports = __webpack_public_path__ + "static/media/DNA-based-Unknown.feaaace7.svg";